const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function amazonProductReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_AMAZON_PRODUCT':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_AMAZON_PRODUCT':
			return {
				...state,
				list: action?.payload?.amazonTrending || [],
				totalsize: action?.payload?.totalsize || 0
			};
		default:
			return state;
	}
}

export default amazonProductReducer;
